export const getOfficeGoalsReportColumns = ({ formatMoney, formatNumber }) => [
  {
    title: "Office",
    dataIndex: "officeName",
    key: "officeName",
    render: (value) => value || "--",
  },
  {
    title: "Deposits",
    dataIndex: "deposits",
    key: "deposits",
    render: (value) => formatMoney(value),
  },
  {
    title: "Withdrawals",
    dataIndex: "withdrawals",
    key: "withdrawals",
    render: (value) => formatMoney(value),
  },
  {
    title: "NMI",
    dataIndex: "nmi",
    key: "nmi",
    render: (value) => formatMoney(value),
  },
  {
    title: "FTD",
    dataIndex: "ftd",
    key: "ftd",
    render: (value) => formatNumber(value, 0),
  },
  {
    title: "Volume",
    dataIndex: "volume",
    key: "volume",
    render: (value) => formatMoney(value),
  },
  {
    title: "Conv.",
    dataIndex: "conversionRatio",
    key: "conversionRatio",
    render: (value) => `${formatNumber(value)}%`,
  },
];
